import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Tenant, AdminUser } from '@/types';

/**
 * 认证状态
 */
interface AuthState {
  token: string | null;
  user: AdminUser | null;
  isAuthenticated: boolean;
  setAuth: (token: string, user: AdminUser) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      setAuth: (token, user) => set({ token, user, isAuthenticated: true }),
      logout: () => set({ token: null, user: null, isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
    }
  )
);

/**
 * 全局状态
 */
interface GlobalState {
  currentTenant: Tenant | null;
  collapsed: boolean;
  setCurrentTenant: (tenant: Tenant | null) => void;
  toggleCollapsed: () => void;
}

export const useGlobalStore = create<GlobalState>()((set) => ({
  currentTenant: null,
  collapsed: false,
  setCurrentTenant: (tenant) => set({ currentTenant: tenant }),
  toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
}));
